<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        Jadwal Angsuran
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>

      <b-row>
        <b-col lg="10">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Agreement No.</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.no_agreement"
                  @keyup.13.native="lkuPinjamanShow=true"
                  :state="!$v.model.pinjamankey.$error"
                ></b-form-input>
                <b-input-group-append v-if="!isdetail">
                  <b-btn text="Button" @click="lkuPinjamanShow=true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:100px">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.no_kontrak" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur Name</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.CustName" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
               <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur No. (CIF)</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.CustCode" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tenor</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tenor" readonly class="text-right"></b-form-input>
                <b-input-group-prepend><span class="input-group-text" style="width:70px;">Bulan</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col lg="6">
               <b-input-group>
                <b-input-group-prepend>
                  <label>Go Live - Maturity Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.startdate_frmt" readonly></b-form-input>
                <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
                    <b-form-input v-model="model.duedate_frmt" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Effective Rate (%)</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.bunga_tarifthn" readonly class="text-right"></b-form-input>
                <b-input-group-prepend><span class="input-group-text" style="width:70px;">%</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Virtual Account No</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.vanumber" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Penggunaan</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.purpose_of_fin_name" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Cessie Group</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.pjxname" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Branch</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.branch" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>LDSK</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.LDSK" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <!-- <b-col lg="5">
          <b-col lg="12">
            <b-input-group>
              <b-input-group-prepend v-if="model.model_pinjaman=='PAB'">
                <label>Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label>Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number
                v-if="model.model_pinjaman=='PAB'"
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <my-number
                v-else
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Jangka Waktu</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.tenor"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">bulan</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bunga_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.model_pinjaman=='PAB'">
              <b-input-group-prepend>
                <label>Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.installment_amount"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label>Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.interestod"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col> -->
      </b-row>
      <hr />
      <b-row>
        <b-col lg="10">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>DOD</label>
                </b-input-group-prepend>
                 <my-number
                  class="form-control text-right"
                  v-model="model.days_over_due"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS LC Installament</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.latecharge_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Principal</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.principal_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Interest</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.interest_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Principal Undue</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.principal_outstand_undue"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Interest Undue</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.interest_outstand_undue"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment	</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.next_installment_no"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment Date	</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.next_installment_date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment Due No	</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.next_installment_due_no"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Due Date	</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.next_installment_due_date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="12">
          <div class="text-right mb-2">
            <button class="btn btn-primary mr-1" @click="printAllAngsuranpdf()" :disabled="!this.model.pinjamankey">
            <i class="fa fa-print"></i> Seluruh Angsuran
          </button>
           <button class="btn btn-warning mr-1" @click="printOSAngsuranpdf()" :disabled="!this.model.pinjamankey">
            <i class="fa fa-print"></i> Sisa Angsuran
          </button>
          <button class="btn btn-info mr-1 text-black" @click="exportJdwlAngsuran" :disabled="!this.model.pinjamankey">
            <i class="fa fa-file-excel-o"></i> Export Excell
          </button>
          <button class="btn btn-success mr-1 text-black" @click="getData" :disabled="!this.model.pinjamankey">
            <i class="fa fa-refresh"></i> Reload
          </button>
          </div>
        </b-col>
      </b-row>
      <b-card border-variant="info" align="center" no-body>
        <template v-slot:header>
          <h6>Jadwal Angsuran</h6>
        </template>
        <b-table
          sticky-header 
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          small
          style="font-size:smaller;max-height:500px !important;"
          :items="tblData.items"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          :busy="isBusyTblAngsuran"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
          :tbody-tr-class="rowClass"
          show-empty
        >
          <template v-slot:cell(angsuran_ke)="data">
            <div style="width:100%;height:100%">{{ data.item.angsuran_ke }}</div>
          </template>
          <template
            v-slot:cell(tgl_jttempo)="data"
          >{{ data.item.tgl_jttempo | moment("DD/MM/YYYY") }}</template>
          <template
            v-slot:cell(inst_paid_date)="data"
          >{{ data.item.inst_paid_date | moment("DD/MM/YYYY") }}</template>
          <template
            v-slot:cell(end_of_date)="data"
          >{{ data.item.end_of_date | moment("DD/MM/YYYY hh:mm") }}</template>
          <template v-slot:cell(inst_paid_amt)="data">{{ (data.item.settle_pokok+data.item.settle_bunga) | numFormat("0,0.00") }}</template>
          <template v-slot:cell(nilai_pokok)="data">{{ data.item.nilai_pokok | numFormat("0,0.00") }}</template>
          <template v-slot:cell(nilai_bunga)="data">{{ data.item.nilai_bunga | numFormat("0,0.00") }}</template>
          <template v-slot:cell(angsuran)="data">{{ data.item.angsuran | numFormat("0,0.00") }}</template>
          <template v-slot:cell(outstand_pokok)="data">{{ ((data.item.outstand_pokok ||0)>0.009 ?data.item.outstand_pokok:0 ) | numFormat("0,0.00") }}</template>
          <template v-slot:cell(outstand_bunga)="data">{{ ((data.item.outstand_bunga ||0)>0.009 ? data.item.outstand_bunga:0) | numFormat("0,0.00") }}</template>
          <template v-slot:cell(outstand_denda)="data">{{ data.item.outstand_denda | numFormat("0,0.00") }}</template>
          <template v-slot:cell(akum_denda)="data">{{ data.item.akum_denda | numFormat("0,0.00") }}</template>
          <template v-slot:cell(settle_denda)="data">{{ data.item.settle_denda | numFormat("0,0.00") }}</template>
          <template
            v-slot:cell(waktupelunasan)="data"
          >{{ data.item.waktupelunasan | moment("DD MMM YYYY") }}</template>
          <template v-slot:cell(flag)="data"></template>
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
              <b-dropdown text="Action" size="sm">
                <b-dropdown-item v-if="data.item.final==0">Revisi</b-dropdown-item>
                <b-dropdown-item v-if="data.item.model_pinjaman=='PAB'">Jadwal Angsuran</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item v-if="data.item.cair==1">Detail Denda/Bunga RK</b-dropdown-item>
                <b-dropdown-item v-if="data.item.cair==1">Collection Activity</b-dropdown-item>
                <b-dropdown-item v-if="data.item.cair==1">Permohonan Pelunasan</b-dropdown-item>
                <b-dropdown-item v-if="data.item.cair==1">History Payment & Settlement</b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="3">
            <div align="left">
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to
              <span
                v-if="((tblData.page * tblData.limit)>tblData.total)"
              >{{tblData.total}}</span>
              <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries
            </div>
          </b-col>
          <b-col cols="3">
            <b-form-group label style="margin-top:0 !important;">
              <b-input-group>
                <b-input-group-prepend class="mr-2">
                  <label>Limit per page</label>
                </b-input-group-prepend>
                <div class="d-flex">
                  <b-form-select
                    :options="[10, 15, 20, 25,50,75,100]"
                    :plain="true"
                    v-model="tblData.limit"
                    size="sm"
                    style="width:80px"
                  />
                </div>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Yg Sdh Terbayar</label>
              </b-input-group-prepend>
              <b-form-checkbox
                v-model="filter"
                value
                unchecked-value="unpaid"
                switch
                style="width:50px;    padding: 8px 0px;"
              ></b-form-checkbox>
            </b-input-group>
          </b-col>
          <b-col cols="3">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman" :modelpinjaman="model.model_pinjaman"></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>   
  </div>
</template>

<style lang="scss" scoped>
  .table-red-text{
    color:red;
  }
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import Loading from 'vue-loading-overlay';

import myNumber from "../../components/my-number";
import lkuPinjaman from "./lkuPinjaman";
import pinjaman from "../../apis/pinjamankredit";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, myNumber, lkuPinjaman },
  mixins: [validationMixin],
  validations: {
    model: {
      pinjamankey: { required },
    },
  },
  data() {
    return {
      showReport:false,
      reportUrl:null,
      isLoading:false,
      model: { pinjamankey: "",printall:1,
      next_installment_no:0,
      next_installment_date:'',
      next_installment_due_no:0,
      next_installment_due_date:'',
      principal_outstand_undue:0,
      interest_outstand_undue:0
      },
      lkuPinjamanShow: false,
      tblData: {
        page: 1,
        limit: 50,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: this.$store.state.user.akhirbln,
        sortBy: "nokontrak",
        sortDesc: false,
      },
      isdetail: false,
      isBusyTblAngsuran: false,
      filter: "unpaid",
      filterOn: ["statuspay"],
    };
  },
  props: ["modelpinjaman"],
  computed: {
    tblFields() {
      const fields = [
        {
          key: "angsuran_ke",
          label: "Angsuran Ke-",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tgl_jttempo",
          label: "Tgl. Jatuh Tempo",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "angsuran",
          label: "Angsuran (IDR)",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "inst_paid_amt",
          label: "Installment Paid",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "inst_paid_date",
          label: "Tgl. Bayar",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilai_pokok",
          label: "Pokok",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilai_bunga",
          label: "Bunga(IDR)",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_pokok",
          label: "Outstand Pokok",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_bunga",
          label: "Outstand Bunga",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "lc_days",
          label: "Keterlambatan\n (Hari)",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        
        {
          key: "akum_denda",
          label: "LC Amt.",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "settle_denda",
          label: "LC Amt. Paid",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        // {
        //   key: "end_of_date",
        //   label: "As of",
        //   thStyle: "width:140px",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   sortable: true,
        // },
        // {
        //   key: "outstand_denda",
        //   label: "Outstand Denda",
        //   thStyle: "width:140px",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   sortable: true,
        // },
        // {
        //   key: "sisa_pokok",
        //   label: "Sisa Pinjaman Pokok",
        //   thStyle: "width:140px",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   sortable: true,
        // },
        // {
        //   key: "interestod",
        //   label: "Bunga OD(%)",
        //   thStyle: "width:90px",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   sortable: true
        // },
        // {
        //   key: "koletibilitas",
        //   label: "Kolektibilitas",
        //   thStyle: "width:60px",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   sortable: true
        // }
        // {
        //   key: "action",
        //   label: "",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   thStyle: "width:60px"
        // }
      ];
      return fields;
    },
  },
  beforeUpdate: function () {},
  created: async function () {
    if (this.$route.params.pinjamankey) {
      this.model.pinjamankey = this.$route.params.pinjamankey;
      this.isdetail = true; // flag dari action pada daftar pinjaman
      this.getData();
    } else {
      this.model.model_pinjaman = this.modelpinjaman;
    }
  },
  methods: {
    rowClass(item, type) {
      const today = moment().format('YYYY-MM-DD');
        if ((item && item.outstand_bunga ||0)>0.009 || (item && item.outstand_pokok||0) > 0.009) {
          if(moment(today).diff(moment(item.tgl_jttempo),'days')>-1){
            return 'text-danger';
          }else{
            return '';
          }
            
        }else{
          return '';
        }
        
      },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    onSelectLkuPinjaman(_selected) {
      this.model.pinjamankey = _selected.pinjamankey;
      this.getData();
      this.lkuPinjamanShow = false;
    },
    close() {
      router.push({ name: "loan.pinjaman" });
    },
    async getData() {
      try {
        this.isLoading = true;
        const pinjamankey = this.model.pinjamankey;
        this.isBusyTblAngsuran = true;
        const [data] = await pinjaman.detail(pinjamankey);
        const dtpinjaman = data[0][0];
        for (const key in dtpinjaman) {
          if (dtpinjaman.hasOwnProperty(key)) {
            this.model[key] = dtpinjaman[key];
          }
        }
        this.model.tgl_kontrak = moment(this.model.tgl_kontrak).format(
          "YYYY-MM-DD"
        );
        this.model.startdate_frmt = moment(this.model.startdate).format('DD-MM-YYYY');
        this.model.duedate_frmt = moment(this.model.duedate).format('DD-MM-YYYY');
        this.model.next_installment_date= moment(this.model.next_installment_date).format('DD-MM-YYYY');
        this.model.next_installment_due_date= moment(this.model.next_installment_due_date).format('DD-MM-YYYY');
        this.listAgunan = data[1];
        data[2].map((item, index) => {
          if (item.outstand_bunga >0.009 || item.outstand_pokok > 0.009) {
            data[2][index].statuspay = "unpaid";
          } else {
            data[2][index]._rowVariant = "success";
            data[2][index].statuspay = "paid";
          }
        });
        this.tblData.items = data[2];
        this.tblData.total = data[2].length;
        // this.tblData.page = Math.ceil(
        //   dtpinjaman.paym_install_no / this.tblData.limit
        // );
        this.isBusyTblAngsuran = false;
        // toastr.clear;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    printOSAngsuranpdf(){
      this.model.printall=0;
      this.printpdf();
    },
    printAllAngsuranpdf(){
              this.model.printall=1;
      this.printpdf();
    },
    async printpdf(){
      try {
        this.isLoading=true;
        this.reportUrl = await pinjaman.printjdwlangsuran(this.model);
        this.isLoading=false;
        this.showReport= true;
      } catch (error) {
        this.showReport= false;
        this.isLoading=false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    async exportJdwlAngsuran(){
      try {
          this.isLoading=true;
          console.log("#this.model: ", this.model);
          await pinjaman.exportJdwlAngsuran(this.model.pinjamankey);
          this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    }
  },
};
</script>
